import { render, staticRenderFns } from "./BoxTarget.vue?vue&type=template&id=77490791&"
import script from "./BoxTarget.vue?vue&type=script&lang=ts&"
export * from "./BoxTarget.vue?vue&type=script&lang=ts&"
import style0 from "./BoxTarget.vue?vue&type=style&index=0&id=77490791&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QCard,QSkeleton,QInnerLoading,QTabPanels} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QCard,QSkeleton,QInnerLoading,QTabPanels})
